import React from "react";

import "./style.scss";
import Helmet from "./helmet";
import Header from "./header";
import Midsection from "./midsection";
import Footer from "./footer";

const Layout = ({ children }) => (
  <div>
    <Helmet />
    <section className="hero is-fullheight-with-navbar gradientBg">
      <Header />
      {children}
      {/* 	<Midsection /> <Footer />*/}
    </section>
  </div>
);

export default Layout;
